module.exports = "<imagePic *ngIf=\"(item$ | meta).images\" [images]=\"(item$ | meta).images\"></imagePic>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/image-item/image-item.component.html
// module id = 699
// module chunks = 2